import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

// Shared helper – triggers a file download from a blob response
const triggerDownload = (response) => {
    const href = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = href;
    const suggestedFileName = response.headers["x-suggested-filename"];
    link.setAttribute('download', suggestedFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

const downloadOrdersReport = async (subsiteId) => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/orders",
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadOrdersOverviewReport = async (dates, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/ordersoverview",
        { dates },
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadCatalogPurchaseReport = async (dates = {}, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/catalogpurchase",
        dates,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadStyleCatalogReport = async (styleCode, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/stylecatalog",
        { styleCode },
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadUserDetailsReport = async (userId, subsiteId) => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/userdetails/" + userId,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadZeroInventoryReport = async (subsiteId) => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/zeroinventory",
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadAllSubsitesZeroInventoryReport = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/allsubsiteszeroinventory",
        { headers: AuthHeader.authHeader(), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadCachedAllSubsitesZeroInventoryReport = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/allsubsiteszeroinventory/cached",
        { headers: AuthHeader.authHeader(), responseType: 'blob' }
    );
    triggerDownload(response);
};

const getCachedAllSubsitesZeroInventoryReportInfo = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/allsubsiteszeroinventory/cached/info",
        { headers: AuthHeader.authHeader() }
    );
    return response.data;
};

const downloadIgniteProductsOrderedReport = async (dates = {}, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/igniteproductsordered",
        dates,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadTransactionsReport = async (dates = {}, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/transactions",
        dates,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadUserSubsiteReport = async (subsiteId) => {
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/report/usersubsite",
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadCatalogAuditReport = async (dates = {}, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/catalogaudit",
        dates,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadUserAuditReport = async (dates = {}, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/useraudit",
        dates,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const downloadPrintItemOrdersReport = async (dates = {}, subsiteId) => {
    const response = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/report/printitemorders",
        dates,
        { headers: AuthHeader.authHeaderWithSubsite(subsiteId), responseType: 'blob' }
    );
    triggerDownload(response);
};

const ReportService = {
    downloadOrdersReport,
    downloadOrdersOverviewReport,
    downloadCatalogPurchaseReport,
    downloadStyleCatalogReport,
    downloadUserDetailsReport,
    downloadZeroInventoryReport,
    downloadAllSubsitesZeroInventoryReport,
    downloadCachedAllSubsitesZeroInventoryReport,
    getCachedAllSubsitesZeroInventoryReportInfo,
    downloadIgniteProductsOrderedReport,
    downloadTransactionsReport,
    downloadUserSubsiteReport,
    downloadCatalogAuditReport,
    downloadUserAuditReport,
    downloadPrintItemOrdersReport,
};

export default ReportService;
